import { ClientOnly } from "~/design-system/components";
import { SwitchToDeliveryPortal } from "~/modules/checkout/components";
import { CookiePreferencesPortal } from "~/modules/cookies/components";
import {
  RequestCutomCakesPortal,
  RequestWeddingCakesPortal,
  SuccessPortal,
} from "~/modules/home/portals";
import {
  AddAddressPortal,
  CancelOrderPortal,
  DeleteAddressPortal,
  EditAddressPortal,
  LogoutPortal,
  MyAccountSidebarPortal,
} from "~/modules/my-account/components";
import { MobileFiltersPortal } from "~/modules/our-cakes/components";

const portals = [
  LogoutPortal,
  AddAddressPortal,
  EditAddressPortal,
  DeleteAddressPortal,
  RequestWeddingCakesPortal,
  RequestCutomCakesPortal,
  CancelOrderPortal,
  SuccessPortal,
  MobileFiltersPortal,
  MyAccountSidebarPortal,
  CookiePreferencesPortal,
  SwitchToDeliveryPortal,
];

export function PortalsWrapper() {
  return (
    <ClientOnly>
      {portals.map((Portal, index) => (Portal ? <Portal key={index} /> : null))}
    </ClientOnly>
  );
}
